import Table from './table';
import TableHeaderCell from './header-cell';

export type { TableProps } from './table';
export type { HeaderCellProps } from './header-cell';

export const HeaderCell = TableHeaderCell;

export default Table;
